/**
 * URL of the dashboard app (candidate area). Used for "Espace candidat" link from interview.
 * Set via VITE_DASHBOARD_URL (e.g. http://localhost:5174 in dev).
 */
export const getDashboardUrl = (): string =>
  import.meta.env.VITE_DASHBOARD_URL || 'http://localhost:5174';
